export const userDeviceCollectionGuard = 'GET /employees/userdevices';
export const approveUserDeviceResourceGuard = 'PUT /userdevicequeues/d+';
export const denyUserDeviceResourceGuard = 'DELETE /userdevicequeues/d+';
export const deleteUserDeviceResourceGuard = 'DELETE /userdevices/d+';
